// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class AttachmentRequest {
  fileName: string;
  key: string;
  fileSize: number;
  adminRequest: boolean;
}
